import React from "react";

export default function MySQL_INSERT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_INSERT</h1>
      <p>This is the MySQL_INSERT component generated from the SQL JSON.</p>
    </div>
  );
}
